export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-select-bg-white.9b364755.svg","height":33,"width":55};